import { Link } from 'react-router-dom';
import * as analytics from '@utils/analytics';
import './StorefrontLink.css';

/**
 * Turn the profile's `storefrontUrl` into an app route.
 * "sophia-lan-storefront" and "/sophia-lan-storefront" both become "/sophia-lan-storefront".
 * Returns null when there's nothing usable, so the card isn't shown.
 */
export function storefrontPath(storefrontUrl) {
  if (typeof storefrontUrl !== 'string') return null;
  const s = storefrontUrl.trim();
  if (!s) return null;
  return s.startsWith('/') ? s : `/${s}`;
}

/**
 * "Sophia's Storefront" card shown under the profile card.
 * Renders nothing if the member has no `storefrontUrl` on their profile doc.
 *
 *   <StorefrontLink user={user} isMe={isMe} />
 */
export default function StorefrontLink({ user, isMe = false }) {
  const to = storefrontPath(user?.storefrontUrl);
  if (!to) return null;

  const firstName = (user.name || '').split(' ')[0] || 'Their';
  const title = isMe ? 'My Storefront' : `${firstName}'s Storefront`;
  const sub = isMe
    ? 'See your storefront as visitors see it.'
    : `Everything ${firstName} offers, in one place.`;

  const onClick = () => {
    analytics.track('Community Storefront Clicked', {
      profileUid: user.uid,
      storefrontUrl: to,
      isOwnProfile: isMe,
    });
  };

  return (
    <Link to={to} className="card storefront-link" onClick={onClick}>
      <span className="storefront-link__thumb" aria-hidden="true">
        <svg viewBox="0 0 24 24" width="26" height="26" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
          <path d="M4 9.5 5.5 4h13L20 9.5" />
          <path d="M4 9.5a2.67 2.67 0 0 0 5.33 0 2.67 2.67 0 0 0 5.34 0 2.67 2.67 0 0 0 5.33 0" />
          <path d="M5.5 12.5V20h13v-7.5" />
          <path d="M10 20v-4.5h4V20" />
        </svg>
      </span>
      <span className="storefront-link__text">
        <span className="storefront-link__title">{title}</span>
        <span className="storefront-link__sub">{sub}</span>
      </span>
      <svg className="storefront-link__arrow" viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
        <path d="m9 6 6 6-6 6" />
      </svg>
    </Link>
  );
}
